import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

// @mui
import { Grid, Typography, Box, CircularProgress, Stack, Paper, Avatar } from '@mui/material';

// sections
import { Dashboard, Group, AdminPanelSettings } from '@mui/icons-material';

import { getDashboardData } from '../api/commonAPIs';

// ----------------------------------------------------------------------

export default function AdminDashboard() {

  const [isLoading, setIsLoading] = useState(false)
  const [dashboardData, setDashboardData] = useState(null);
  const loggedUser = useSelector((state) => state.adminUser.user)
  console.log({loggedUser});

  // console.log(adminUserState)
  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data : {data} } = await getDashboardData();

      setDashboardData({ restaurant: data.restaurant, restaurantUser: data.restaurantUser, superAdmin: data.superAdmin })
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // get dashboard data
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title> Dashboard | Facilitaspro </title>
      </Helmet>
      <Box sx={{ height: '100%', width: '100%', }}>
        {!isLoading ?
          <Box ml={1} >
            <Typography variant="h4" >
              Hi, Welcome back!
            </Typography>
            {console.log({ dashboardData })}
            <Stack component={Paper} p={2} mt={2} spacing={2} sx={{ borderRadius: 2 }}>

              <Typography variant='h6'>Summary</Typography>
              {dashboardData &&
                <Grid container >
                  <Grid item xs={12} lg={3} >
                    <Box sx={{ borderRadius: 2, boxShadow: 24, backgroundColor: '#FFE2E5', color: '#000', width: { xs: 110, sm: 160 }, height: { xs: 150, sm: 130 } }}>
                      <Stack p={2} sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-around', borderRadius: 2, height: '100%' }}>
                        <Avatar sx={{ backgroundColor: '#FA5A7D' }}><Dashboard /></Avatar>
                        <Typography variant='h3'>{dashboardData?.restaurant?.total}</Typography>
                        <Typography variant='subtitle1'>Total Restaurant</Typography>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={3} >
                    <Box sx={{ borderRadius: 2, boxShadow: 24, backgroundColor: '#DCFCE7', color: '#000', width: { xs: 110, sm: 160 }, height: { xs: 150, sm: 130 } }}>
                      <Stack p={2} sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-around', borderRadius: 2, height: '100%' }}>
                        <Avatar sx={{ backgroundColor: '#3CD856' }}><Group /></Avatar>
                        <Typography variant='h3'>{dashboardData?.restaurantUser?.total}</Typography>
                        <Typography variant='subtitle1'>Restaurant Users</Typography>
                      </Stack>
                    </Box>
                  </Grid>
                  {loggedUser.role === "superadmin" &&
                  <Grid item xs={12} lg={3} >
                    <Box sx={{ borderRadius: 2, boxShadow: 24, backgroundColor: '#FFF4DE', color: '#000', width: { xs: 110, sm: 160 }, height: { xs: 150, sm: 130 } }}>
                      <Stack p={2} sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-around', borderRadius: 2, height: '100%' }}>
                        <Avatar sx={{ backgroundColor: '#FF947A' }}><AdminPanelSettings /></Avatar>
                        <Typography variant='h3'>{dashboardData?.superAdmin?.total}</Typography>
                        <Typography variant='subtitle1'>Admin</Typography>
                      </Stack>
                    </Box>
                  </Grid>}
                </Grid>
              }
            </Stack>


          </Box>
          :
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><CircularProgress /></Box>}
      </Box>
    </>
  );
}
